import React from "react";
import { makeStyles } from "tss-react/mui";
import ReportSubscriptionItem from "./ReportSubscriptionItem";

const useStyles = makeStyles()(() => ({
	stack: {
		display: "flex",
		flexDirection: "column",
		gap: "8px",
	},
}));

const ReportSubscriptionsList = ({ subscriptions, onToggle, onEdit, onDelete }) => {
	const { classes } = useStyles();
	return (
		<div className={classes.stack}>
			{subscriptions.map((sub) => (
				<ReportSubscriptionItem
					key={sub.id}
					subscription={sub}
					onToggle={onToggle}
					onEdit={onEdit}
					onDelete={onDelete}
				/>
			))}
		</div>
	);
};

export default ReportSubscriptionsList;
